import { eed_web_icon_global_03_action_guanbixiaoxiao_line } from '@/assets/icons';
import { Icon } from '@docs/kd-d2c-components';
import { Popover } from 'antd';
import classNames from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import styles from './AgentChip.module.less';

const DEFAULT_REMOVE_DESCRIPTION = '移除后将开启新Claw会话，确定开启新会话吗？';
const DEFAULT_REMOVE_OK = '确定';
const DEFAULT_REMOVE_CANCEL = '取消';

export interface AgentChipProps {
  name: string;
  avatarUrl?: string;
  disabled?: boolean;
  agentType?: string;
  /** 删除二次确认说明 */
  removeConfirmDescription?: React.ReactNode;
  removeConfirmOkText?: string;
  removeConfirmCancelText?: string;
  onRemove?: () => void;
}

export const AgentChip: React.FC<AgentChipProps> = ({
  name,
  avatarUrl,
  disabled,
  removeConfirmDescription = DEFAULT_REMOVE_DESCRIPTION,
  removeConfirmOkText = DEFAULT_REMOVE_OK,
  removeConfirmCancelText = DEFAULT_REMOVE_CANCEL,
  onRemove,
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (disabled) setOpen(false);
  }, [disabled]);

  const handleOpenChange = useCallback(
    (next: boolean) => {
      if (disabled) return;
      setOpen(next);
    },
    [disabled],
  );

  const handleConfirm = useCallback(() => {
    onRemove?.();
    setOpen(false);
  }, [onRemove]);

  const handleCancel = useCallback(() => {
    setOpen(false);
  }, []);

  const popoverContent = (
    <div className={styles.removePopover}>
      <div className={styles.removePopoverBody}>{removeConfirmDescription}</div>
      <div className={styles.removePopoverFooter}>
        <button
          type="button"
          className={styles.removePopoverBtnCancel}
          onClick={handleCancel}
        >
          {removeConfirmCancelText}
        </button>
        <button
          type="button"
          className={styles.removePopoverBtnOk}
          onClick={handleConfirm}
        >
          {removeConfirmOkText}
        </button>
      </div>
    </div>
  );

  const initial = name.trim().charAt(0) || '?';

  return (
    <div className={classNames(styles.chip, disabled && styles.chipDisabled)}>
      <div className={styles.avatar} aria-hidden>
        {avatarUrl ? (
          <img className={styles.avatarImg} src={avatarUrl} alt="" />
        ) : (
          <span className={styles.avatarFallback}>{initial}</span>
        )}
      </div>
      <span className={styles.name} title={name}>
        {name}
      </span>
      <Popover
        open={open}
        onOpenChange={handleOpenChange}
        trigger="click"
        placement="top"
        arrow={false}
        overlayClassName={styles.popoverRoot}
        getPopupContainer={() => document.body}
        content={popoverContent}
      >
        <button
          type="button"
          className={styles.close}
          aria-label="移除"
          disabled={disabled}
        >
          <Icon
            icon={eed_web_icon_global_03_action_guanbixiaoxiao_line}
            size={16}
            className={styles.closeIcon}
            aria-hidden
          />
        </button>
      </Popover>
    </div>
  );
};

export default AgentChip;
